import { MarketplaceOpportunityStatus } from '../../opportunity/models/opportunity-status';
import { DocumentDetailsContentSubtype } from './enums/document-details-content-subtype';
import { DocumentDetailsContentType } from './enums/document-details-content-type';
import { TimelineActionStatus } from './enums/timeline-action-status.enum';
import { TimelineActionType } from './timeline-action-type.model';

export interface TimelineAction {
    id: number;
    actionType: TimelineActionType;
    status: TimelineActionStatus;
    dataNdaTermId?: string;
    loiAndDdNdaExecutionConfigId?: string | null;
    referenceItemId?: string;
    oldReferenceItemIds?: string[];
    oldReferenceItemAdditionalVersionIds?: Partial<
        Record<keyof typeof DocumentDetailsContentSubtype, string[]>
    >;
    actionReferenceId?: number;
    actionReferenceDefinitionId?: string;
    buyerStatus?: MarketplaceOpportunityStatus;
    previousBuyerStatus?: MarketplaceOpportunityStatus;
    minPrice?: number;
    maxPrice?: number;
    documentDetailsId?: string;
    loiFormId?: string;
    lastActorName?: string;
    lastActorUserId?: number;
    buyerActionStatus?: TimelineActionStatus;
    buyerStateCreatedAtUtc?: string;
    buyerStateModifiedAtUtc?: string;
    isSelectionFinalized?: boolean;
    // On a selection finalized before a break: the buyers who reached the step from a catch-up, still the Seller's to decide.
    buyerIdsNewToTheSelection?: number[];
    documentContentType?: DocumentDetailsContentType | null;
}

export const defaultTimelineAction: TimelineAction = {
    id: 0,
    actionType: TimelineActionType.BuyerExpressionOfInterest,
    status: TimelineActionStatus.InProgress,
};

export const defaultAdditionalOldRefIdsField = (): Partial<
    Record<keyof typeof DocumentDetailsContentSubtype, string[]>
> => {
    return {
        StaffBlinded: [],
        DvmsBlinded: [],
        Visible: [],
    };
};

export const isValidAdditionalOldRefIdsField = (
    obj: Partial<Record<keyof typeof DocumentDetailsContentSubtype, string[]>>
) => {
    if (!obj) return false;

    return !!obj.DvmsBlinded && !!obj.DvmsBlinded && !!obj.StaffBlinded;
};
